'use client'

import PropTypes from 'prop-types'

import { dateIsToday, dateIsYesterday, formatDate, parseDate } from '@repo/utils/time'
import { DateSeparator } from '@repo/ui/DateSeparator'
import { useEffect, useState } from 'react'

export const TimeRecordingDateSeparator = ({ title = '20240901', sx }) => {
  const [dateToDisplay, setDateToDisplay] = useState()

  useEffect(() => {
    if (title === 'Active') {
      setDateToDisplay('Active')
    } else {
      const parsedDate = parseDate(title)

      let format = 'EEE d MMM'
      const currentYear = new Date().getFullYear()
      const titleYear = parsedDate.getFullYear()
      if (titleYear !== currentYear) format = 'EEE d MMM yyyy'
      let dateToDisplay = formatDate(parsedDate, format)

      if (dateIsToday(title, 'yyyyMMdd')) dateToDisplay = 'Today'
      else if (dateIsYesterday(title, 'yyyyMMdd')) dateToDisplay = 'Yesterday'

      setDateToDisplay(dateToDisplay)
    }
  }, [title])

  return (
    <div data-testid="TimeRecordingDateSeparator">
      <DateSeparator dateToDisplay={dateToDisplay} textColor={'text.primary'} sx={{ mb: 3, mt: 3, ...sx }} />
    </div>
  )
}

TimeRecordingDateSeparator.propTypes = {
  title: PropTypes.string,
  sx: PropTypes.object
}
